<img
  src="https://superlikers-themes.s3.us-east-1.amazonaws.com/tonicorp/register.webp"
  alt="icon_register"
  class="max-h-96 w-full object-contain" />

<p class="text-center text-2xl leading-8 font-extrabold tracking-[0] italic">COMPLETA EL REGISTRO</p>
<p class="text-blue-cyan-light text-center text-base leading-6 font-bold tracking-[0] italic">
  Activa tu perfil y únete a la carrera por los mejores resultados.
</p>

@if (error()) {
  <p class="text-red-600">{{ error() }}</p>
}

<form
  autocomplete="off"
  [formGroup]="form"
  (ngSubmit)="submit()"
  class="mx-auto flex w-full max-w-lg flex-col gap-4 px-4">
  <div class="text-blue-teal relative">
    <input
      formControlName="password"
      placeholder="CREAR CONTRASEÑA"
      appTogglePassword
      class="border-blue-teal text-blue-teal placeholder-blue-teal h-12 w-full rounded-lg border p-2 text-base leading-6 font-bold italic" />
  </div>
  <div class="text-blue-teal">
    <input
      formControlName="password_confirmation"
      placeholder="VERIFICAR CONTRASEÑA"
      appTogglePassword
      class="border-blue-teal text-blue-teal placeholder-blue-teal h-12 w-full rounded-lg border p-2 text-base leading-6 font-bold italic" />
  </div>

  <button
    class="button1 h-10 w-full"
    [disabled]="form.invalid || loading()"
    type="submit">
    ¡LISTO PARA CORRER!
  </button>
</form>
